import React from 'react';

/**
 * Placeholder rendered while dynamic fields are being fetched from an action handler.
 * Shows a pulsing grid of shimmer bars matching typical field layout.
 */
export function DynamicFieldsSkeleton(): React.ReactElement {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '16px 24px',
        padding: '8px 0',
      }}
      aria-busy="true"
      aria-label="Loading dynamic fields"
    >
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          style={{
            height: 40,
            borderRadius: 6,
            background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 1.5s infinite ease-in-out',
          }}
        />
      ))}
      <style>{`@keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }`}</style>
    </div>
  );
}
